import React from 'react';
import { inputType } from '../constants';

function Input(props) {
	const {
		id,
		type,
		value,
		label,
		onChange,
		showCounter = false,
		...rest
	} = props;

	return (
		<div className="input-wrap">
			<label htmlFor={id}>{label}</label>
			{type === inputType.textarea ? (
				<div>
					<textarea
						id={id}
						defaultValue={value}
						onChange={onChange}
						{...rest}
					></textarea>
					{showCounter && <span>{value?.length ?? 0}/900</span>}
				</div>
			) : (
				<input
					id={id}
					type={type}
					defaultValue={value}
					onChange={onChange}
					{...rest}
				></input>
			)}
		</div>
	);
}

export default Input;
